namespace RioERP.Masters {
    export interface TawkToChatRow {
        Id?: number;
        ChatId?: string;
        StartTime?: string;
        Name?: string;
        Email?: string;
        Mobile?: string;
        SerialKey?: string;
        HandledBy?: number;
        ChatLog?: string;
        EndTime?: string;
        TawkToEvent?: Web.Enums.TawkToEvent;
        Department?: Web.Enums.Department;
        Note?: string;
        Subject?: string;
        CustomerId?: number;
        IsActive?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace TawkToChatRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ChatId';
        export const localTextPrefix = 'Masters.TawkToChat';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            ChatId = "ChatId",
            StartTime = "StartTime",
            Name = "Name",
            Email = "Email",
            Mobile = "Mobile",
            SerialKey = "SerialKey",
            HandledBy = "HandledBy",
            ChatLog = "ChatLog",
            EndTime = "EndTime",
            TawkToEvent = "TawkToEvent",
            Department = "Department",
            Note = "Note",
            Subject = "Subject",
            CustomerId = "CustomerId",
            IsActive = "IsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
